import { render, staticRenderFns } from "./WarehouseModal.vue?vue&type=template&id=cba18d20&"
import script from "./WarehouseModal.vue?vue&type=script&lang=js&"
export * from "./WarehouseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports